document.addEventListener('DOMContentLoaded', function () {
  let secondaryNavs = document.querySelectorAll('[data-navigation]');
  secondaryNavs = [].slice.call(secondaryNavs, 1); 
  secondaryNavs.forEach(function (nav) {
    let navItems = nav.querySelectorAll('[data-submenu-parent]');
    navItems.forEach(function (navItem) {
      let navButton = navItem.querySelector('[data-dropdown-trigger]');
      let submenu = navItem.querySelector('[data-submenu]');
      
      navButton.addEventListener('mouseover', function (e) {
        submenu.classList.add('active');
      });
      
    })

    nav.addEventListener('mouseleave', function () {
      let submenu = nav.querySelector('.active[data-submenu]');
      submenu.classList.remove('active');
    })
  })
})
